<template>
    <div class="el-col el-col-24"> 
        <span :span="1" :offset="1">学年：</span>
        <el-select v-model="yearID" :span="6" @change="selectChange('year')">
            <el-option v-for="item in selectyears" :key="item.yearID" :label="item.yearName" :value="item.yearID"></el-option>
        </el-select>
        <span :span="1" :offset="1">年级：</span>
        <el-select v-model="gradeID" :span="6" @change="selectChange()">
            <el-option v-for="item in selectgrades" :key="item.gradeID" :label="item.gradeName" :value="item.gradeID"></el-option>
        </el-select>
        <span :span="1" :offset="1">班级：</span>
        <el-select v-model="classID" :span="6">
            <el-option v-for="item in selectclass" :key="item.classID" :label="item.className" :value="item.classID"></el-option>
        </el-select>
        <!-- <el-button @click="get()">点击</el-button> -->
    </div>
</template>
<script>
import { Select} from 'element-ui'
import api from '../../../com/ajax'
import config from '../../../com/config'

export default {
  name: 'app',
    components: {
        Select
    },
    data () {
        return {
            // 对象属性
           yearID:'',
           gradeID:'',
           classID:'',
           selectyears:[],
           selectgrades:[],
           selectclass:[],
           orgID:''
        }
    },
    props:{
    },
    watch:{
       
    },
    methods:{
         selectChange(sel){//由年级得到班级
            var that = this
            var param
            if(sel=='year'){
                param={"orgID":that.orgID,"yearID":that.yearID}
            }else{ 
                param={"orgID":that.orgID,"yearID":that.yearID,"gradeID":that.gradeID}
            }
            api.post(config.khsHost +'base/forHhs/class/getClassList.do',param).then(function (response){
                if (response.success == true) {

                    that.selectclass = response.body.list
                    that.selectclass.splice(0, 0, { 'classID': '', 'className': '全部' })
                }
            })
        }
    },
    mounted: function(){  
    },
    created: function(){
        var that = this;
        getId.$on('change',function(val){
            that.orgID=val
            api.post(config.khsHost +'base/forHhs/term/getYearList.do',{"orgID":that.orgID}).then(function (response) {

                    if (response.success == true) {

                        that.selectyears = response.body.list
                        that.yearID = response.body.list[0].yearID
                        that.yearName=response.body.list[0].yearName

                         api.post(config.khsHost +'base/forHhs/grade/getGradeList.do',{"orgID":that.orgID}).then(function (response) {

                                if (response.success == true) {

                                    that.selectgrades = response.body.list
                                    that.selectgrades.splice(0, 0, { 'gradeID': '', 'gradeName': '全部' })
                                     api.post(config.khsHost +'base/forHhs/class/getClassList.do',{"orgID":that.orgID,"yearID":that.yearID,"gradeID":''}).then(function (response) {

                                            if (response.success == true) {

                                                that.selectclass = response.body.list
                                                that.selectclass.splice(0, 0, { 'classID': '', 'className': '全部' })
                                            }
                                      
                                    })
                                }
                          
                        })

                        
                       
                    }
              
            })
        })   
        
    },
    beforeDestroy: function () {

        // 销毁前状态
        getId.$off('change');
    },
}
</script>


// WEBPACK FOOTER //
// src/components/reports/codeCom/yearGradeAndClass.vue?26fbf745